// redux/measurementRequest/measurementRequestSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    requests: [],
    selectedRequest: null,
    isLoading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 20,
        total: 0,
        totalPages: 0
    },
    filters: {
        status: 'PENDING',
        request_type: 'ALL'
    }
};

const measurementRequestSlice = createSlice({
    name: "measurementRequest",
    initialState,
    reducers: {
        setRequests: (state, action) => {
            state.requests = action.payload;
        },
        setSelectedRequest: (state, action) => {
            state.selectedRequest = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        updateRequestInList: (state, action) => {
            const index = state.requests.findIndex(r => r._id === action.payload._id);
            if (index !== -1) {
                state.requests[index] = action.payload;
            }
            if (state.selectedRequest?._id === action.payload._id) {
                state.selectedRequest = action.payload;
            }
        },
        removeRequest: (state, action) => {
            state.requests = state.requests.filter(r => r._id !== action.payload);
            if (state.selectedRequest?._id === action.payload) {
                state.selectedRequest = null;
            }
        },
        clearRequests: (state) => {
            state.requests = [];
            state.selectedRequest = null;
            state.pagination = initialState.pagination;
        }
    }
});

export const {
    setRequests,
    setSelectedRequest,
    setLoading,
    setError,
    setPagination,
    setFilters,
    updateRequestInList,
    removeRequest,
    clearRequests
} = measurementRequestSlice.actions;

export const MeasurementRequestReducer = measurementRequestSlice.reducer;